import type { PathsManifest } from '@zg-rentals/route-list';
import { registerBrowserRoutes } from '@zg-rentals/route-list';
import { BASE_PATH } from '../constants/sharedConfig';

function pathsManifest() {
  function formatUrl(url = '') {
    if (url) {
      return `${BASE_PATH}/${url}`;
    } else {
      return `${BASE_PATH}`;
    }
  }

  /* tslint:disable:max-line-length */
  return {
    // pages
    base: formatUrl(),
    devToolsPage: formatUrl('devtools'),
    inboxPage: formatUrl(),
    leadsPage: '/rental-manager/leads',
    leadManagementPage: '/rental-manager/lead-management',

    // ZRM Pages
    host: 'https://www.zillow.com',
    homePage: 'https://www.zillow.com/rental-manager',

    // ZRM Sub-routes
    propertyDetailsContacts: 'contacts',
    propertyDetailsListing: 'listing',

    //hotpads
    adminPage: '/admin',
    experimentPage: 'https://hotpads.com/node/rep/abtests',
    repsPage: '/rep',
    salesPage: '/sales',
    //end hotpads

    //zillow
    applicationsUrl: '/rental-manager/applications',
    fsboPage: '/for-sale-by-owner',
    multifamilyAdvertisingPage: 'https://www.zillow.com/marketing/rental-property-advertising',
    resourcesPage: '/rental-manager/resources/',
    mfhResourcesPage: '/multifamily-knowledge-center/',
    tenantScreeningPage: 'https://www.zillow.com/marketing/rental-manager/tenant-screening/',
    zestimatePage: '/info/what-is-a-rent-zestimate/',
    impersonatePage: 'https://www.zillow.com/user/Impersonate.htm',
    zillowLogoutPage: '/Logout.htm',
    corpTermsURL: 'https://www.zillow.com/corp/Terms.htm',
    rentalTermsURL: 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms',
    pledgeURL: 'https://www.zillow.com/corp/respectful-renting-pledge/',
    photosFormat: 'https://www.zillow.help/article/do-the-photos-need-to-be-a-certain-format-and-size-zd30234452011667',
    virtualTours: 'https://www.zillow.com/rental-manager/resources/tips-for-managing-virtual-tours/',
    //end zillow

    // Export Excel Paths
    exportExcel: {
      leadsForListing: '/users/leads/exportExcelLeadsForListing',
      leadsForUser: '/users/leads/exportExcelLeadsForUser',
      adSpendAll: '/users/analytics/adproducts/exportExcel',
      boostAd: '/users/analytics/cpmBoostStats/exportExcel',
      properties: '/users/analytics/properties/exportExcel',
    },

    stopImpersonatingPage: 'https://www.zillow.com/user/Impersonate.htm?stop=1',

    myPropertiesPage: 'https://www.zillow.com/rental-manager/properties',
    myPropertiesPagePath: '/properties',
    myPropertiesPageWithBasePath: '/rental-manager/properties',

    createLeasePage: (listingAlias: string) => `/leasing/property/${listingAlias}/create`,

    globalContactsPage: 'https://www.zillow.com/rental-manager/contacts',

    // RMW Mobile Apps
    iOS: 'https://itunes.apple.com/us/app/postlets-post-rentals-free/id759202892?ls=1&mt=8',
    android: 'https://play.google.com/store/apps/details?id=com.zillow.postlet',

    hud: 'http://www.hud.gov/offices/fheo/index.cfm',

    profilePage: '/user/EditProfile.htm',

    helpPage: 'https://www.zillow.help/renter-landlord-property-manager',

    userSettingsPage: '/rental-manager/settings',

    proxyPath: '/rental-manager/proxy',

    logout: '/rental-manager',

    marketingRoutes: {
      onboarding: {
        applications: formatUrl('properties/applications'),
        payments: formatUrl('properties/payments'),
      },
      screening: formatUrl('tenant-screening'),
      collectRent: formatUrl('collect-rent-online'),
      screeningLangingPage: 'https://www.zillow.com/marketing/landlord/tenant-screening/',
      collectRentLandingPage: 'https://www.zillow.com/marketing/rental-manager/collect-rent-online/',
    },
  };
}

registerBrowserRoutes(pathsManifest() as PathsManifest);

export default pathsManifest;
